﻿import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import classes from "../maintainers.module.scss";
import { datetimeToLocale, formatMilesDecimal, hasPermission, userName, validRoles } from "@/services/Utils";

import { ReactComponent as PencilSvg } from "@/assets/images/desktop/editar.svg";
import { ReactComponent as RemoveSvg } from "@/assets/images/desktop/remove.svg";
import CustomBadge from "@/components/desktop/badge/CustomBadge";
import CustomTooltip from "@/components/desktop/tooltip/CustomTooltip";
import { decimalFormatOptions, localString } from "@/components/global.constants";

const ApplicationsTableBody = ({ data, handleDelete, permissions }) => {
	const navigate = useNavigate();

	const userRoles = JSON.parse(localStorage.getItem("roles"));
	const isAdmin = validRoles(userRoles, ["administrador"]);

	const { user } = useSelector((state) => state.auth);

	return (
		<tbody>
			{data &&
				data.map((item, i) => {
					return (
						<tr className={`${classes.table_tr}`} key={i}>
							{isAdmin && (
								<td className={`${classes.table_td} ${classes.first_td}`}>
									<div className={`${classes.table_div}`} style={{ paddingLeft: "8px" }}>
										{item.customer}
									</div>
								</td>
							)}

							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.center}`}>
									<strong> {item.code}</strong>
								</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.center}`}>
									{Number(item.entry) === 1 ? (
										<CustomBadge variant="success">Entrada</CustomBadge>
									) : (
										<CustomBadge variant="warning">Salida</CustomBadge>
									)}
								</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.center}`}>{datetimeToLocale(item.date_weight)}</div>
							</td>
							{isAdmin && (
								<td className={`${classes.table_td}`}>
									<div className={`${classes.table_div} ${classes.center}`}>
										{Number(item.entry) === 1 ? (item.weight ? item.weight.toLocaleString(localString, decimalFormatOptions) : 0) : 0}
									</div>
								</td>
							)}
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.center}`}>
									{isAdmin ? (
										<>{Number(item.entry) === 1 ? formatMilesDecimal(item.weight_used) : formatMilesDecimal(item.output_weight)}</>
									) : (
										<>
											{Number(item.entry) === 1 ? formatMilesDecimal(item.weight_used_user) : formatMilesDecimal(item.output_weight_user)}{" "}
											{item.unit_measurement}
										</>
									)}
								</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.center}`}>
									<CustomTooltip text={userName(item.user)} description={item.user} />
								</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.center}`}>
									{Number(item.empty_container) === 1 ? (
										<CustomBadge variant="success">Si</CustomBadge>
									) : (
										<CustomBadge variant="danger">No</CustomBadge>
									)}
								</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.center}`}>
									{Number(item.not_used) === 1 ? (
										<CustomBadge variant="success">Si</CustomBadge>
									) : (
										<CustomBadge variant="danger">No</CustomBadge>
									)}
								</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.last_div}`}>
									{user.user_id !== 17 && (
										<>
											{hasPermission("edit", permissions) && (
												<PencilSvg
													className={classes.icon}
													onClick={() => navigate("/mantenedores/aplicaciones/editar/" + item.applications_history_id)}
												/>
											)}
											{hasPermission("delete", permissions) && <RemoveSvg className={classes.icon} onClick={() => handleDelete(item)} />}
										</>
									)}
								</div>
							</td>
						</tr>
					);
				})}
		</tbody>
	);
};

export default ApplicationsTableBody;
